export default "9934302ca8b0bca5.svg"